export const CONTACT_US_INITIAL_VALUES = {
    email: "",
    mobile: "",
    message: "",
    lname: "",
    fname: "",
  };
  
  export const SUPPORT_INITIAL_VALUES = {
    name: "",
    email: "",
    mobile: "",
    message: "",
    company: "",
    natureOfwork: "",
  };
  
  export const SEND_APP_LINK_INITIAL_VALUES = {
    mobile: "",
  };
  
  export const SIGNIN_INITIAL_VALUES = {
    email: "",
    password: "",
  };
  
  export const MERCHANT_SIGNUP_INITIAL_VALUES = {
    email: "",
    landline: "",
    fname: "",
    lname: "",
    password: "",
    city: "",
    state: "",
    address: "",
    // category: "business",
    profile: "",
    dob: "",
    zip: "",
    trail: "",
    buisnessname: "",
    // servicesTypes: [],
    // services: [],
  };
  
  export const CREATE_CAMPAIGN_INITIAL_VALUES = {
    // tab 1 starts
    value: "",
    discount: "",
    startDate: "",
    title: "",
    endDate: "",
    description: "",
    weeks: "", //new
    noOfcampaigns: "",
    validPerWeek: "",//new
    options: ["online"],
    cover: null,
    // tab 1 ended
  
    // tab 2 starts
    CampaignsPurchasablePerCustomer: "10",
    repurchaseCampaignAfter: "30",
    amountPaidNeverExpires: "", //new
    additionalFinePrint: "", //new
    holdername: "", //new
    bankname: "", //new
    businessAccount: "", //new
    accNo: "", //new
    ssn_taxid: "", //new
    routingNo: "",
    website: "",
    details: "",
    google_mybusiness: "",
    yelp: "",
    menu: null,
    // logo: null,
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
  };
  
  export const SOCIAL_MEDIA_INITIAL_VALUES = {
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
    website: "",
  };
  